<div id="participantContainer" class="d-flex justify-content-end">
  <div class="users-list-container">
    <app-game-mode *ngIf="gameState.isStarted"></app-game-mode>

    <!-- USERS: -->
    <div id="userList" [ngClass]="{'game-mode-on' : gameState.isStarted}">

      <!-- NONE-GAME MODE -->
      <ng-container *ngIf="!gameState.isStarted">
        <ng-container *ngFor="let user of usersListService.listUsers[-1]; let i = index">
          <div class="user-row"
               *ngIf="user.additionalInfo.isClassParticipant || user.additionalInfo.roomConnectionStatus !== ConnectionStatus.OFFLINE">
            <app-user-list-item
              [remoteUser]="user"
              [index]="i"
              [studentsCount]="usersListService.listUsers[-1].length">
            </app-user-list-item>
          </div>
        </ng-container>
      </ng-container>

      <!-- GAME MODE - TEAM USERS -->
      <div *ngIf="gameState.isStarted">
        <div *ngFor="let team of gameState.teams; let i = index"
          class="stud-team-wrap {{'team-color-index_' + (team.colorIndex ?? 1)}} position-relative my-4">
          <div class="stud-team-name d-flex align-items-center">
            <span class="team-name-text text-truncate" title="{{team.name}}">{{team.name}}</span>
            <div class="stud-team-btns d-flex align-items-center">
              <div *ngIf="this.localUser.accessType !== AccessType.OBSERVER"
                   class="btn user-btn team-sticker-buttons d-flex align-items-center">
                <button class="btn team-sticker-button" title="Add Winner Sticker"
                        (click)="addTeamSticker(team.id)"></button>
                <span class="separator"></span>
                <button class="btn" title="Remove Winner Sticker"
                        (click)="removeTeamSticker(team.id)"><i class="far fa-minus"></i></button>
              </div>
              <button
                (click)="removeScoreFromTeam(team.id)"
                *ngIf="this.localUser.accessType !== AccessType.OBSERVER"
                [disabled]="usersListService.listUsers[i]?.length === 0 || gameState.scoreByTeamId[team.id] === 0"
                class="btn team-score-btn" title="Remove point"><i class="far fa-minus"></i></button>
              <span class="stud-team-score mx-2">{{gameState.scoreByTeamId[team.id]}}</span>
              <button
                (click)="addScoreToTeam(team.id)"
                *ngIf="this.localUser.accessType !== AccessType.OBSERVER"
                [disabled]="usersListService.listUsers[i]?.length === 0"
                class="btn team-score-btn" title="Add point"><i class="far fa-plus"></i></button>
              <button class="btn applause-button" title="Applause"
                      *ngIf="this.localUser.accessType !== AccessType.OBSERVER"
                      [ngClass]="{'active': isApplauseSoundPlaying(team.id)}"
                      (click)="playApplauseAudio(team.id)"></button>
            </div>
          </div>
          <span class="no-data-txt"
            *ngIf="team.participantIds.length === 0">No students</span>
          <ng-container *ngFor="let user of usersListService.listUsers[i]">

            <div class="user-row"
                 *ngIf="user.additionalInfo.isClassParticipant || user.additionalInfo.roomConnectionStatus !== ConnectionStatus.OFFLINE">
              <app-user-list-item
                [remoteUser]="user"
                [index]="i"
                [studentsCount]="usersListService.listUsers[i].length">
              </app-user-list-item>
            </div>
          </ng-container>

        </div>
      </div>

      <!-- GAME MODE - NONE-TEAM USERS -->
      <div *ngIf="gameState.isStarted && usersListService.listUsers[-1]">
        <div class="other-studs-list">
          <div class="font-size-12 font-weight-bold mb-2">OTHER STUDENTS</div>
          <ng-container
            *ngFor="let user of usersListService.listUsers[-1]; let i= index">
            <div class="user-row"
                 *ngIf="user.additionalInfo.isClassParticipant || user.additionalInfo.roomConnectionStatus !== ConnectionStatus.OFFLINE">
              <app-user-list-item
                [remoteUser]="user"
                [index]="i"
                [studentsCount]="usersListService.listUsers[-1].length">
              </app-user-list-item>
            </div>
          </ng-container>

        </div>
      </div>

      <!-- SELF - SUPPORT or OBSERVER -->
      <div class="user-row" *ngIf="localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.OBSERVER">
        <app-local-user-list-item></app-local-user-list-item>
      </div>
    </div>
  </div>

  <div class="chat-tab-tools-wrapper d-flex flex-column"
       *ngIf="gameState.isStarted && localUser.accessType === AccessType.OBSERVER">
    <button class="team-talk"
            (click)="toggleTeamTalk()"
            title="{{gameState.isTeamTalkOn ? 'Stop Team Talk': 'Start Team Talk'}}"
            [ngClass]="{'on': gameState.isTeamTalkOn}"
            style="cursor :default"></button>
  </div>

  <div class="chat-tab-tools-wrapper d-flex flex-column"
       *ngIf="localUser.accessType !== AccessType.OBSERVER">

    <button class="team-talk"
            (click)="toggleTeamTalk()"
            title="{{gameState.isTeamTalkOn ? 'Stop Team Talk': 'Start Team Talk'}}"
            [ngClass]="{'on': gameState.isTeamTalkOn}"
            *ngIf="gameState.isStarted"></button>

    <button class="edit-teams"
            (click)="openEditTeamsDialog()"
            title="Edit Teams"
            *ngIf="gameState.isStarted && (localUser.accessType  === AccessType.SUPPORT || localUser.accessType === AccessType.TEACHER)">
    </button>
    <hr *ngIf="gameState.isStarted">

    <button class="clear-chat"
            (click)="cleanAllMessages()"
            *ngIf="localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.TEACHER"
            title="Clear chat [Alt-C]">
    </button>

    <button class="clear-counters"
      *ngIf="localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.TEACHER"
      (click)="resetAllCorrectCounters()"
      title="Reset all counters">
    </button>

    <button *ngIf="localUser.accessType === AccessType.SUPPORT" type="button" class="button user-button-more"
      title="Admin panel"
      style="margin-bottom: 0"
      placement="left"
      [popover]="classroomRedirect"
      outsideClick="outsideClick"
      containerClass="cs-popover multilevel">
      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
    </button>

    <ng-template #classroomRedirect>

    <div class="userMoreOptions-popover">
        <div class="btn-group" dropdown #dropdown="bs-dropdown" [isOpen]="status.isOpenRedirect" [insideClick]="true" autoClose="autoClose">
          <button type="button" class="button redirect-class-button" title="Redirect All Users to a Classroom"
            dropdownToggle></button>
          <div class="dropdown-menu" *dropdownMenu>
            <div class="" style="padding: 3px">
              <form (ngSubmit)="redirectClassroom()" ngNativeValidate>
                <div class="input-group">
                  <input type="number" class="form-control number-input-without-arrow " (click)="$event.stopPropagation()"
                    name="classroomNumber" [(ngModel)]="classroomNumber" [required]="true" min="100" max="9999">
                  <span class="input-group-btn">
                    <button class="btn btn-default" (click)="status.isOpenRedirect=true" type="submit">Redirect</button>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="btn-group">
          <button type="button" class="button reset-btn fas fa-sync-alt" title="Reset"
            (click)="resetWebRTCCall()">
          </button>
        </div>

        <div class="btn-group">
          <button type="button" class="button reset-btn fas fa-duotone fa-retweet" title="Reset Classroom"
            (click)="resetClassroom()">
          </button>
        </div>
      </div>

    </ng-template>


    <!--    <script type="text/ng-template" id="classroomMoreOptions.html">-->
    <!--          <div class="userMoreOptions-popover small" ng-class="{'first-line': userIndex<3 && !isOpenedFromList}">-->
    <!--            <div class="btn-group" uib-dropdown is-open="status.isOpenRedirect" auto-close="outsideClick">-->
    <!--              <button type="button" class="button redirect-class-button" title="Redirect All Users to a Classroom" uib-dropdown-toggle></button>-->
    <!--              <div class="dropdown-menu" uib-dropdown-menu>-->
    <!--                <div class="" style="padding: 3px">-->
    <!--                  <form ng-submit="redirectClassroom(classroomNumber); status.isOpenRedirect=false">-->
    <!--                    <div class="input-group">-->
    <!--                      <input type="number" class="form-control number-input-without-arrow "-->
    <!--                        onClick="event.stopPropagation()" ng-model="classroomNumber"-->
    <!--                        ng-required="true" min="1" max="9999">-->
    <!--                      <span class="input-group-btn">-->
    <!--                                              <button class="btn btn-default" ng-click="status.isOpenRedirect=true" type="submit">Redirect</button>-->
    <!--                                          </span>-->
    <!--                    </div>-->
    <!--                  </form>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->

    <!--            <div class="btn-group">-->
    <!--              <button type="button" class="button reset-btn fas fa-sync-alt" title="Reset"-->
    <!--                ng-click="resetWebRTCCall()"></button>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--    </script>-->

  </div>
</div>
